/* eslint-disable max-len */
import Sidenav from '@brands/Dashboard/Sidenav/Sidenav';
import { useWindowSize } from '@brands/hooks';
import { sendResetEmail } from '@brands/services/auth/sendResetEmail';
import { formatEmail } from '@brands/Utils/formatDate';
import TextButton from '@mui/material/Button';
import React, { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';

import Button from '../../Components/Button/Button';
import { customStylesForgotPassword } from '../../Utils/customStyles';
import { displayErrorDetails } from '../../Utils/displayError';
import styles from './styles.module.scss';
import leftArrow from './utils/icons/leftArrow.svg';

interface ForgotPasswordModalConfirmationProps {
  forgotPasswordStep: number;
  setForgotPasswordStep: (num: number) => void;
  credentials: ForgotPasswordCredentials;
  setCredentials: (credentials: ForgotPasswordCredentials) => void;
}

type ForgotPasswordCredentials = {
  username?: string;
  code: string;
  new_password: string;
  reset_password_hash?: string;
};

const ForgotPasswordModalConfirmation: FC<ForgotPasswordModalConfirmationProps> = ({
  forgotPasswordStep,
  setForgotPasswordStep,
  credentials,
  setCredentials,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isMobile = useWindowSize().width < 992;
  const closeModal = (): void => {
    setForgotPasswordStep(0);
    setCredentials({
      username: '',
      code: '',
      new_password: '',
    });
  };

  useEffect(() => {
    if (forgotPasswordStep === 5) {
      document.body.classList.add('modal-open');
    } else if (document.body.classList.contains('modal-open') && forgotPasswordStep === 0) {
      document.body.classList.remove('modal-open');
    }
  }, [forgotPasswordStep]);

  const onSubmit = async (): Promise<void> => {
    try {
      setLoading(true);
      await sendResetEmail({ email: credentials.username as string });
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      // closeModal();
      setLoading(false);
    }
  };
  return (
    <div className={styles.container}>
      <Sidenav isVisibleOnMobile hideDefaultOptions authLoog hideModals={() => setForgotPasswordStep(0)} />
      <Modal
        isOpen={forgotPasswordStep === 5}
        onRequestClose={closeModal}
        style={customStylesForgotPassword(isMobile, '40%')}
        contentLabel="Modal"
        ariaHideApp={false}
        className={`${styles.wrapper} ${styles.forgotPasswordModal}`}
        shouldCloseOnOverlayClick={false}
      >
        <form className={styles.formContainer}>
          <span className={`${styles.formTitle} p-b-26`}>
            <span className={`${styles.formTitleForgot} fs-unmask`}>Reset your password</span>
            <div className={`text-center ${styles.formTitleLink} p-t-115 fs-unmask`}>
              <span className={`${styles.txt1} txt1`}>
                We've sent a recovery link to <strong>{formatEmail((credentials.username as string) || '')}</strong>. If
                you don't see the email in your inbox, please check your spam folder.
              </span>
            </div>
          </span>
          <div className={styles.buttonContainer}>
            <div className={styles.buttonWrapper}>
              <Button type="button" onClick={onSubmit} className={styles.formBtn} disabled={loading}>
                Resend Recovery Link
              </Button>
            </div>
          </div>
          <div className={`${styles.backArrow}`} style={{ margin: '16px 0' }}>
            <TextButton
              variant="text"
              onClick={() => {
                closeModal();
                navigate('/');
              }}
            >
              <img src={leftArrow} />
              <span>back to sign in</span>
            </TextButton>
          </div>
        </form>
      </Modal>
    </div>
  );
};

Modal.setAppElement('#root');

export default ForgotPasswordModalConfirmation;
